export default "__VITE_ASSET__DwC4eHUV__"